import {NfMessage, NfMessageType} from "../NfMessage";

/**
 * Wiadomość, gdy brakuje id zakładki
 */
export class GetBrowserTabId extends NfMessage {
    public constructor() {
        super(NfMessageType.GetBrowserTabId);
    }
    public type = NfMessageType.GetBrowserTabId;
}
NfMessage.creationCallbacks[NfMessageType.GetBrowserTabId] = (event) => {
    const message =  new GetBrowserTabId();
    return message;
}
